export class RequestLimitExceededError extends Error {
  constructor(
    readonly loaded: number,
    readonly totalCount: number,
  ) {
    super(`Paginated read stopped at the offset limit after ${loaded} of ${totalCount} items`);
    this.name = 'RequestLimitExceededError';
  }
}
